<template>
  <div class="gcp-list">
    <div class="gcp-list-header">
      <r-title type="subtitle-2">Результаты замеров</r-title>
    </div>
    <ul class="gcp-list-container">
      <li
        class="gcp-list-item"
        v-for="item in list"
        :key="item.id"
        @click="openGcp(item)"
      >
        <div class="gcp-list-item-header">
          <div class="gcp-list-item-icon">
            <r-text type="caption">
              <i
                :class="
                  item.opened
                    ? 'gcp-list-item-icon el-icon-arrow-right gcp-list-item-icon--rotated'
                    : 'gcp-list-item-icon el-icon-arrow-right'
                "
              />
            </r-text>
          </div>
          <div class="gcp-list-item-name">
            <r-text> No {{ item.no }} </r-text>
          </div>
          <div class="gcp-list-item-info">
            <r-text type="caption">
              {{ item.measure_count ? "Занесено" : "Не занесено" }}
            </r-text>
          </div>
        </div>
        <ul class="gcp-list-item-points" v-if="item.opened">
          <li
            :class="getCpClass(subitem.id)"
            v-for="subitem in item.count_points"
            :key="subitem.id"
            @click="flyToCp(subitem, item, $event)"
          >
            <r-text type="caption">Точка {{ subitem.name }}</r-text>
            <r-text type="caption">
              {{ subitem.measure_count ? "Занесено" : "Не занесено" }}
            </r-text>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    state: {
      type: Object,
      required: true
    },
    fillController: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      list: []
    };
  },
  watch: {
    "state.updated": async function(value) {
      if (value) {
        await this.getData();
        this.$set(this.state, "updated", false);
      }
    }
  },
  methods: {
    async getData() {
      try {
        this.loading = true;

        const id = this.$store.state.trafficCount.model.ids[
          "general_count_points"
        ];
        const url = `gcp/${id}?format=with_measure_count`;
        const { data } = await this.$store.dispatch("REQUEST", { url });

        this.list = Object.values(data)
          .sort((a, b) => a.no - b.no)
          .map(gcp => ({
            ...gcp,
            opened: false,
            count_points: gcp.count_points.sort((a, b) => a.name - b.name)
          }));

        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    openGcp(item) {
      const value = !item.opened;

      this.list.forEach(p => this.$set(p, "opened", false));

      this.$set(item, "opened", value);
    },
    flyToCp(cp, gcp, event) {
      event.stopPropagation();

      this.fillController.setActiveCp(cp, cp.geom, gcp);
    },
    getCpClass(id) {
      const { activeCp } = this.$store.state.trafficCount.fill;

      if (id === activeCp) return "gcp-list-item-point active";

      return "gcp-list-item-point";
    }
  },
  created() {
    this.getData();
  }
};
</script>

<style lang="scss">
.gcp-list {
  position: absolute;
  top: 16px;
  left: 16px;
  border-radius: var(--border-radius);
  border: 1px solid transparent;
  background-color: var(--bg_panel_secondary) !important;
  border-color: var(--dividers_low_contrast) !important;
  z-index: 100;
  padding: 16px;
  width: 240px;

  &-container {
    max-height: 40vh;
    overflow: auto;
  }

  &-header {
    margin-bottom: 8px;
  }

  &-item {
    cursor: pointer;
    border-radius: 4px;
    background-color: var(--modal_bg) !important;

    &:not(:first-child) {
      margin-top: 8px;
    }

    &-header {
      display: flex;
      padding: 8px;
    }

    &-icon {
      margin-right: 4px;

      &--rotated {
        transform: rotateZ(90deg);
      }
    }

    &-info {
      margin-left: auto;
    }

    &-points {
      padding-left: 16px;
      padding-right: 8px;
      padding-bottom: 8px;
      margin-top: 4px;
    }

    &-point {
      padding: 4px 8px;
      background-color: var(--bg_panel_secondary) !important;
      border-radius: 4px;
      display: flex;
      justify-content: space-between;

      &:not(:first-child) {
        margin-top: 8px;
      }

      &:hover {
        background-color: rgba(var(--accent_primary), 0.2) !important;
      }
      &:active {
        background-color: rgba(var(--accent_primary), 0.3) !important;
      }

      &.active {
        background: rgba(var(--accent_primary), 0.3) !important;
      }
    }
  }
}
</style>
